import { render, staticRenderFns } from "./tag-color-dialog.vue?vue&type=template&id=4b72e60c&scoped=true&"
import script from "./tag-color-dialog.vue?vue&type=script&lang=js&"
export * from "./tag-color-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b72e60c",
  null
  
)

export default component.exports